<div class="dev">
	<bb-page-header [icon]="'code'" title="DEV screen"></bb-page-header>
	<div class="body-column">
		<h1>DEV screen</h1>
			
		<bb-button (click)="data.show='entity-selector-playout'">
			entity-selector playout
		</bb-button>
			
		<bb-button (click)="data.show='entity-selector-mediaclip'">
			entity-selector mediaclip
		</bb-button>

		<div class="entity-selector" *ngIf="data.show === 'entity-selector-playout'">
			<div class="config">
				bb-entity-selector [entityType]="'playout'" [(ngModel)]="data.adunitPlayoutId"
			</div>
			<div class="value">
				<input type="text" [(ngModel)]="data.adunitPlayoutId" [ngModelOptions]="{standalone: true}"/> json value: {{ adunitPlayoutId | json }}
			</div>
			<div class="component">
				<bb-entity-selector [entityType]="'playout'" [(ngModel)]="data.adunitPlayoutId" [ngModelOptions]="{standalone: true}"></bb-entity-selector>
			</div>
		</div>

		<div class="entity-selector" *ngIf="data.show === 'entity-selector-mediaclip'">
			<div class="config">
				bb-entity-selector [entityType]="'mediaclip'" [(ngModel)]="data.mediaclipId"
			</div>
			<div class="value">
				json value: {{ data.mediaclipId | json }}
			</div>
			<div class="component">
				<bb-entity-selector [entityType]="'mediaclip'" [(ngModel)]="data.mediaclipId" [ngModelOptions]="{standalone: true}"></bb-entity-selector>
			</div>
		</div>

		<div style="background-color: #333333;">
			<ie-form-field 
				[label]="'CSS_CLASS' | translate"
				[useDataSource]="true"
				[useMacroSuggestions]="true"
			>
				<input
					type="text"
					[(ngModel)]="data.cssclass"
					[name]="'chapter_widget_cssclass'"
					class="ie-form-field-styling"
				/>
			</ie-form-field>
		</div>
		

		<div style="background-color: #333333;">
			<ie-form-field 
				[label]="'SOME_TEXT' | translate"
				[useDataSource]="false"
				[useMacroSuggestions]="true"
			>
				<textarea
					type="text"
					[(ngModel)]="data.someText"
					[name]="'someText'"
					class="ie-form-field-styling"
				></textarea>
			</ie-form-field>
		</div>
		

		<div style="background-color: #333333;">
			<ie-form-field 
				[label]="'WITH_ENTITYSELECTOR' | translate"
				[useMacroSuggestions]="true"
			>
				<bb-entity-selector theme="dark" [(ngModel)]="data.testSet" [ngModelOptions]="{standalone: true}" [extendable]="true"></bb-entity-selector>
			</ie-form-field>
		</div>
		<div class="asd">
			testSet: {{ data.testSet }}
		</div>
	</div>
</div>
